import Grid from '@mui/material/Grid';

import { TopMatterWithDetails } from 'reservations/account/components/TopMatterWithDetails';
import AvailabilitiesConfiguration from 'reservations/availabilities/components/AvailabilitiesConfiguration';
import AvailabilitiesContainer from 'reservations/availabilities/components/AvailabilitiesContainer';
import { AVAILABILITIES_CONTAINER_SX } from 'reservations/availabilities/constants';
import { AvailabilitiesProvider } from 'reservations/availabilities/providers/AvailabilitiesProvider';
import { LayoutWithGutter } from 'reservations/base/components/LayoutWithGutter';
import { ModalContainer } from 'reservations/base/components/ModalContainer';
import { useRouteIfAppDisabled } from 'reservations/base/hooks/useRouteIfAppDisabled';
import { useRouteIfReservationsDisabled } from 'reservations/base/hooks/useRouteIfReservationsDisabled';
import BackgroundOverlayImageWrapper from 'reservations/brand/components/BackgroundOverlayImageWrapper';
import Form from 'reservations/form/components/Form';
import WaitlistProvider from 'reservations/waitlist/providers/WaitlistProvider';

type Props = {
  slug: string;
};

function CreateBooking({ slug }: Props) {
  useRouteIfReservationsDisabled();
  useRouteIfAppDisabled();

  return (
    <Form>
      <WaitlistProvider slug={slug}>
        <LayoutWithGutter>
          <Grid container direction="column" marginTop="24px">
            <Grid item>
              <AvailabilitiesProvider>
                <Grid container direction="column" gap="40px">
                  <BackgroundOverlayImageWrapper additionalHeight={150}>
                    <Grid item>
                      <AvailabilitiesConfiguration />
                    </Grid>
                  </BackgroundOverlayImageWrapper>
                  <Grid item sx={AVAILABILITIES_CONTAINER_SX}>
                    <ModalContainer />
                    <AvailabilitiesContainer />
                  </Grid>
                </Grid>
              </AvailabilitiesProvider>
            </Grid>
          </Grid>
        </LayoutWithGutter>
      </WaitlistProvider>
    </Form>
  );
}

function CreateBookingScreen({ slug }: Props) {
  return (
    <>
      <TopMatterWithDetails />
      <CreateBooking data-testid="create-booking-screen" slug={slug} />
    </>
  );
}

export default CreateBookingScreen;
